import { ChangePassword } from "../../../pages";
import routesMap from "../../../routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.RESET_PASSWORD.path,
      name: "Resume Details",
      key: routesMap.RESET_PASSWORD.path,
      commonRoute: false,
      private: true,
      belongsToSidebar: false,
      element: <ChangePassword />,
    },
  ];
}
